module.exports = __webpack_public_path__ + "static/media/TopUp.2f0b9781.svg";